<template>
  <div>
    <v-list style="width: 100%" class="driverList">
      <template v-for="(driver, index) in drivers">
        <v-flex @click="goToDriver(driver.id)" pa-1 pl-2 v-bind:style="colorForRow(index)">
          <v-row>
            <v-flex xs1>
              <img
                style="margin-top: 6px;"
                height="36"
                width="36"
                :src="driver.picture"
                onerror="this.style.display='none'"
              />
            </v-flex>
            <v-flex xs11>
              <v-col>
                <v-row>
                  <td style="width: 32%">
                    <a href="javascript:void(0)"  @click="openDriverDetails(driver.id)">
                      {{driver.callsign}} {{driver.name}}
                    </a>
                  </td>
                  <td>{{ driver.taxi.registration_number }}</td>
                  <td>{{ driver.taxi.colour + ' ' + driver.taxi.make + ' ' + driver.taxi.model}}</td>
                  <v-flex style="font-size: 12px;">
                    <v-row justify="end">
                      <div
                        style="margin-right: 8px; margin-top: 1px; backgroundColor: #FFDFC4; padding: 2px; padding-left: 4px; padding-right: 4px; border-radius: 4px;"
                      >
                        <p style="color: #FF953A; ">{{driver.current_rating.toFixed(1)}}</p>
                      </div>
                      <div
                        v-if="driver.likelyWorking"
                        style="margin-right: 8px; margin-top: 1px; color: #278EF4; backgroundColor: #E3F2FD; padding: 2px; padding-left: 4px; padding-right: 4px; border-radius: 4px;"
                      >{{"LIKELY WORKING"}}</div>
                      <div
                        v-if="driver.online"
                        style="margin-right: 8px; margin-top: 1px; color: #2EBB84; backgroundColor: #D9F3E9; padding: 2px; padding-left: 4px; padding-right: 4px; border-radius: 4px;"
                      >{{"ON"}}</div>

                      <div
                        v-if="!driver.online"
                        style="margin-right: 8px; margin-top: 1px; color: #FF0000; backgroundColor: #F3D9E9; padding: 2px; padding-left: 4px; padding-right: 4px; border-radius: 4px;"
                      >{{"OFF"}}</div>
                    </v-row>
                  </v-flex>
                </v-row>
                <v-row style="color: grey; fontSize: 12px;">
                  <v-row>
                    <td style="width: 32%">
                      <a
                        v-on:click.stop="doNothing()"
                        :href="'mailto:'+(driver.email)"
                      >{{ driver.email }}</a>
                      <br />
                      <a
                        v-on:click.stop="doNothing()"
                        :href="'tel:'+formatNumber(driver.phone)"
                      >{{ driver.phone }}</a>
                    </td>

                    <td>
                      {{ (driver.taxi.ride_type_id == null || driver.taxi.ride_type_id == 0) ? "" : nameForRideType(driver.taxi.ride_type_id) }}
                      {{ driver.taxi.num_seats }} seats
                    </td>
                    <v-flex style="font-size: 12px; padding-left: 12px; padding-top: 2px;">
                      <v-row justify="start">
                        <AttributesForTaxiCell :taxi="driver.taxi"></AttributesForTaxiCell>
                      </v-row>
                    </v-flex>
                  </v-row>
                </v-row>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </template>
    </v-list>
  </div>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";

export default {
  name: "driver_summary_list",
  components: {
    AttributesForTaxiCell
  },
  props: {
    drivers: Array,
    paginationProp: Object,
    searchValues: Object
  },
  mounted: function() {
    this.getRideTypes();
  },
  data: function() {
    return {
      rideTypes: [],
      pagination: this.paginationProp,
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "picture"
        },
        {
          text: "Callsign",
          align: "left",
          sortable: false,
          value: "callsign"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Contact Number",
          align: "left",
          sortable: false,
          value: "contact_number"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email"
        },
        {
          text: "Taxi",
          align: "left",
          sortable: false,
          value: "taxi"
        },
        {
          text: "Ride Type",
          align: "left",
          sortable: false,
          value: "ride_type"
        },
        {
          text: "Seats",
          align: "left",
          sortable: false,
          value: "seats"
        },
        {
          text: "Vehicle",
          align: "left",
          sortable: false,
          value: "vehicle"
        },
        {
          text: "Capabilities",
          align: "left",
          sortable: false,
          value: "capabilities"
        },
        {
          text: "Rating",
          align: "left",
          sortable: false,
          value: "rating"
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  methods: {
    search: function() {
      this.$emit("search")
    },
    colorForRow: function(index) {
      var color = index % 2 == 1 ? "white" : "#F0F1F6";

      return {
        backgroundColor: color
      };
    },
    getRideTypes: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.rideTypes = response.data;

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    nameForRideType: function(id) {
      var rt = this.rideTypes.find(function(rt) {
        return rt.id == id;
      });

      return rt ? rt.name : "";
    },
    goToDriver: function(id) {
      this.$emit("driverSelected", id);
    },
    openDriverDetails: function(id) {
      window.open('/drivers/' + id)
    },
    doNothing: function() {},
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}

.driverList {
  font-size: 12px;
  font-weight: 500;
}
</style>
